module.exports = __webpack_public_path__ + "static/media/c4bannerModulF_small.9d1393b3.jpg";